import { render, staticRenderFns } from "./MassNotifyBooks.vue?vue&type=template&id=7febafe4&scoped=true&"
import script from "./MassNotifyBooks.vue?vue&type=script&lang=ts&"
export * from "./MassNotifyBooks.vue?vue&type=script&lang=ts&"
import style0 from "./MassNotifyBooks.vue?vue&type=style&index=0&id=7febafe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7febafe4",
  null
  
)

export default component.exports